<script setup lang="ts">
import { Flag } from 'lucide-vue-next';
import { ComplianceStatus } from 'pejer/src/tables/Global';
import { cn } from '../lib/utils';

defineProps<{
  value: (typeof ComplianceStatus)[number] | null
  class?: any
}>()
</script>

<template>
  <Flag
    :size="16"
    :class="
      cn('shrink-0', $props.class, {
        'fill-gray-300 stroke-gray-300': value === null,
        'fill-green-400 stroke-green-400': value === 'Green',
        'fill-yellow-400 stroke-yellow-400': value === 'Yellow',
        'fill-red-400 stroke-red-400': value === 'Red',
      })
    "
  />
</template>
